import { httpClient } from "@/services";

export default {
	state: {
		dataTable: null,
		trip: { filterLoadFiletType: [] },
		sendShow: false,
		mileage: null,
		gross: null,
		dates: [],
		ppw: [],
		GeneratedPPW: {}
	},
	getters: {
		getMileage(state) {
			return state.mileage;
		},
		getData(state) {
			return state.dataTable.trips;
		},
		getTotals(state) {
			if (state.dataTable) {
				return state.dataTable.totals;
			}
		},
		getTotalTrips(state) {
			return state.dataTable.total;
		}
	},
	actions: {
		async getFile({ dispatch }, values) {
			dispatch("actionPreloader", true);
			const { route, filter } = values;
			try {
				const { data } = await httpClient.post(route, filter);
				dispatch("actionPreloader", false);
				if (data && !data.error) {
					return data;
				}
				dispatch("setAlert", {
					type: "error",
					message: data.error,
				});

			} catch (e) {
				console.error(e);
			}
		},
		async getLocation(context, values) {
			try {
				const { data } = await httpClient.post('/location', values);
				return data.location;
			} catch (e) {
				console.error(e);
			}
		}
	},
};
